































import Content from '@/components/common/Content.vue'
import { Component, Watch } from 'vue-property-decorator'
import Configuration from "@/components/products/railway/steps/ConfigurationImpl.vue"
import Design from "@/components/products/railway/design/DesignImpl.vue"
import Warning from "@/components/common/Warning.vue"
import RailwayHeadline from "@/components/products/railway/RailwayHeadline.vue"
import ProductPreview from "@/components/products/railway/design/ProductPreviewImpl.vue"
import { AppModule, Step } from "@/store/modules/app"
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'
import CartButton from "@/components/products/railway/util/CartButton.vue"
import Gift from "@/components/products/railway/GiftImpl.vue"
import GiftOptionsButton from "@/components/products/railway/RailwayGiftOptionsButton.vue"
import { RailwayModule } from '../../../store/modules/railway'
import TagCommander from "@/components/common/TagCommander.vue"
import ShippingOverlay from "@/components/common/ShippingOverlay.vue"
import Impressum from '@/components/Impressum.vue'

@Component({
  name: "railway-content",
  components: {
    RailwayHeadline,
    Design,
    Configuration,
    Warning,
    ProductPreview,
    CartButton,
    GiftOptionsButton,
    Gift,
    TagCommander,
    ShippingOverlay,
    Impressum
  }
})
export default class RailwayContent extends Content {
  private showCartButton: boolean = true
  private titleTextConfig: TextCanvasConfig = new TextCanvasConfig(13.6, 13.6, 1.5, 134, 21, '"Myriad Pro", sans-serif', 1, "600")
  private railwayPlaceholderStyle: string = "position: absolute; top: 0px; width: 0px;"
  private initIsRunning = false

  get showGiftOptions() {
    return AppModule.showGiftOptions
  }

  get showMenu() {
    return AppModule.showMenu
  }

  toggleFooterButton(state:boolean) {
    this.showCartButton = state
  }

  created() {
    this.initSteps()
    this.initProductName()
  }

  initSteps(): void {
    let railwayTextConfig =  new TextCanvasConfig(11.5, 17.5, 1.15, 167, 128, '"Myriad Pro", sans-serif', 2, "600")
    AppModule.SET_STEPS([
      new Step(this.$t('railwayStepOne').toString(), "enter-title", false, '', [[150, 150], [600, 600], [48,38]], "", this.titleTextConfig, undefined),
      new Step(this.$t('railwayStepTwo').toString(), "railway-image-upload", false, 'innerImage', [[203, 156.275], [1000, 800], [88,87]], this.$t('railwayStepTwoInfo').toString(), undefined, this.railwayPlaceholderStyle),
      new Step(this.$t('railwayStepThree').toString(), "enter-dedication", true, '', [[230, 173], [600, 600], [74,74]], "", railwayTextConfig, this.railwayPlaceholderStyle)
    ])
  }

  initProductName(): void {
    if(!AppModule.productID) {
      AppModule.SetProductID("63604500")
    }
  }

}
